import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiSelect } from 'primereact/multiselect';
import { FormControlLabel, Checkbox, Typography, Button } from '@mui/material';

import '../../scss/primeReactDataTable.scss';
import '../../scss/refundStatus.scss';
import classNames from 'classnames';
const RefundTable = (props: any) => {
	const [globalFilter] = useState('');
	const [isFilterHidden, setIsFilterHidden] = useState(false);

	const { data } = props;

	const onColumnToggle = (e: any) => {
		const selectedColumns = e.value;
		const orderedSelectedColumns = columns.filter((col) =>
			selectedColumns.includes(col),
		);
		setselectedColumns(orderedSelectedColumns);
	};

	const onFiltersShow = (isFilterShown: any) => {
		setIsFilterHidden(isFilterShown);
	};

	const genericBodyTemplate = (rowData: any, column: any) => (
		<>
			<Typography className="p-column-title">{column.header} :</Typography>
			<Typography>{rowData[column.field]}</Typography>
		</>
	);

	const Status = (rowData: any) => {
		return (
			<>
				{rowData.status ? (
					<>
						<Typography className="p-column-title">Client Status:</Typography>
						<span
							className={classNames(
								'refund-status',
								'status-' + rowData.status,
							)}>
							{rowData.status}
						</span>
					</>
				) : (
					<> </>
				)}
			</>
		);
	};

	const [columns] = useState([
		{ field: 'campaignName', header: 'Campaign Name', body: genericBodyTemplate },
		{ field: 'advertisementName', header: 'Ad Name', body: genericBodyTemplate },
		{ field: 'status', header: 'Payment Status', body: Status },
	]);

	const [selectedColumns, setselectedColumns] = useState([
		{ field: 'campaignName', header: 'Campaign Name', body: genericBodyTemplate },
		{ field: 'advertisementName', header: 'Ad Name', body: genericBodyTemplate },
		{ field: 'status', header: 'Payment Status', body: Status },
	]);

	const columnComponents = selectedColumns.map((col: any) => {
		return (
			<Column
				key={col.field}
				field={col.field}
				body={col.body}
				header={col.header}
				sortable={true}
				filter={isFilterHidden}
			/>
		);
	});

	const header = (
		<>
			<div>
				<span style={{ float: 'left' }}>
					<MultiSelect
						value={selectedColumns}
						options={columns}
						optionLabel="header"
						onChange={(e) => onColumnToggle(e)}
						style={{ width: '350px', border: 'none' }}
					/>
				</span>
				<div style={{ textAlign: 'right' }}>
					<FormControlLabel
						control={
							<Checkbox
								name="showFilters"
								color="primary"
                style={{color:'#042630'}}
								onChange={(e) => onFiltersShow(e.target.checked)}
							/>
						}
						label="Show Filters"
					/>
				</div>
			</div>
		</>
	);

	// const scheduleTemplate = (rowData: any) => {
	// 	return (
	// 		<>
	// 			<Typography className="p-column-title">Schedule Details:</Typography>
	// 			<Button
	// 				variant="outlined"
	// 				color="primary"
	// 				onClick={props.showRescheduleDetails.bind(null, rowData)}>
	// 				Reschedule Details
	// 			</Button>
	// 		</>
	// 	);
	// };
	const paymentTemplate = (rowData: any) => {
		return (
			<>
				<Typography className="p-column-title">Payment Details:</Typography>
				<Button
					variant="outlined"
          style={{color:"#042630",borderColor:"#848484"}}
					onClick={props.showPayment.bind(null, rowData)}>
					Payment
				</Button>
			</>
		);
	};

	return (
		<div className="datatable-responsive-demo"  style={{margin:"15px"}}>
			<div className="card">
				<DataTable
					resizableColumns
					columnResizeMode="expand"
					className="p-datatable-customers p-datatable-responsive-demo"
					value={data}
					reorderableColumns={true}
					globalFilter={globalFilter}
					emptyMessage="No records found"
					paginator={true}
					header={header}
					paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink
  LastPageLink CurrentPageReport RowsPerPageDropdown"
					currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
					rows={10}
					rowsPerPageOptions={[5, 10, 20]}
					selectionMode="single">
					{columnComponents}
					{/* <Column
						field="payment"
						header="Schedule Details"
						body={scheduleTemplate}
					/> */}
					<Column
						field="payment"
						header="Payment Details"
						body={paymentTemplate}
					/>
				</DataTable>
			</div>
		</div>
	);
};

export default RefundTable;
